import { useMemo } from "react";
import { MenuItem } from "utils/types/menu";

import CategoryDivider from "components/Atoms/CategoryDivider";

import { useDatastoresFromTypes } from "hooks/datastores/useDatastores";
import { StyledMenu } from "components/Organisms/DatastoresMenu/DatastoreCategory/styles";

interface Type {
  [key: string]: {
    items: MenuItem[];
  };
}

interface DatastoreCategoryProps {
  category: [string, Type];
}

const DatastoreCategory = ({ category }: DatastoreCategoryProps) => {
  const [category_name, datastore_types] = category;

  const datastore_types_names = useMemo(
    () => Object.keys(datastore_types),
    [datastore_types]
  );

  const { datastores: items } = useDatastoresFromTypes(datastore_types_names);
  if (!items?.length) return null;

  return (
    <div key={category_name}>
      <CategoryDivider
        className="datastore-category"
        categoryName={category_name}
      />

      <StyledMenu mode="inline" inlineIndent={15} items={items} />
    </div>
  );
};

export default DatastoreCategory;
